import React from 'react';
import { ButtonBase, DialogContent } from '@material-ui/core';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { useStyles } from './useStyles';
import { ChannelIcon } from 'src/components/ChannelIcon';
import { RESOURCE_CHANNELS } from 'src/data/performance';
import { getChannelLabel } from 'src/data/channel';

export const Select = ({ onTypeSelect }) => {
  const styles = useStyles();

  return (
    <DialogContent className={styles.root}>
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.paragraph14}
        className={styles.label}
      >
        Create talking point views to surface the top-performing talking points from your website,
        competitor's website, connected channels, reviews, and public URLs.
      </CustomTypography>

      <div className={styles.buttonsWrapper}>
        {RESOURCE_CHANNELS.map((resource) => (
          <ButtonBase
            key={resource}
            className={styles.button}
            onClick={onTypeSelect}
            value={resource}
          >
            <ChannelIcon
              className={styles.icon}
              channel={resource}
            />
            {getChannelLabel(resource)}
          </ButtonBase>
        ))}
      </div>
    </DialogContent>
  );
};
